module.exports = __webpack_public_path__ + "img/microsoft-word.4d0d0036.svg";